import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const getRequestBody = (data: any) => {
  return {
    id: data?.id,
    mid: data?.mid,
    packageName: data?.packageName,
  }
}

const deletePackageToMId = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingMid2PackDelete),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: data,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { deletePackageToMId }
